import { Reveal, Overline } from "@/components/Motion";

const OwnerNote = () => (
  <section className="bg-wine text-cream py-28 sm:py-36 relative overflow-hidden" data-testid="owner-note-section">
    <span className="absolute -top-10 left-6 lg:left-16 font-serif text-[220px] leading-none text-cream/[0.07] select-none" aria-hidden="true">
      “
    </span>
    <div className="mx-auto max-w-[900px] px-6 lg:px-12 relative">
      <Reveal>
        <Overline className="text-brass">A Note from the Founder</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-5">
          Dear <span className="italic text-brass">Guest,</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-8 space-y-6 text-cream/85 text-base sm:text-lg font-light leading-relaxed" data-testid="owner-note-text">
          <p>
            Forco Amore began as a simple dream — one table where the romance of Italy and the
            warmth of India could sit together. Every plate that leaves our kitchen carries that
            dream: pasta rolled by hand each morning, dals that simmer through the night, breads
            pulled fresh from the tandoor and the wood-fire.
          </p>
          <p>
            We built this place the way you'd build a home — slowly, stubbornly, and with far too
            much love. So when you walk through our doors, you're not a customer to us. You're a
            guest at our family table. Come hungry, stay long, and let us take care of the rest.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-12">
          <p className="font-serif italic text-3xl sm:text-4xl text-brass" data-testid="owner-note-signature">
            With amore,
          </p>
          <p className="mt-2 font-serif italic text-4xl sm:text-5xl text-cream" data-testid="owner-note-founder-name">
            Anu
          </p>
          <p className="mt-3 text-sm tracking-[0.3em] uppercase text-cream/70">
            Founder, Forco Amore
          </p>
          <p className="mt-1 text-xs tracking-[0.2em] uppercase text-cream/40">
            Vridaradhya Hospitality Private Limited
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default OwnerNote;
